import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class GeoCodingService {
  constructor(private http: HttpClient) {}

  getLocation(lat:number, lng:number): Observable<any> {
    const url = `https://maps.google.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${environment.agm_apikey}`;
    return this.http.get<any>(url);
  }
}